import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DocumentService } from 'src/app/_services/document.services';
import { AlertService } from 'src/app/_services/alert.service';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { FormArray, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';


//import { schema } from './schema.value';

@Component({
  selector: 'app-view-metadata',
  templateUrl: './view-metadata.component.html',
  styleUrls: ['./view-metadata.component.scss'],
  providers: [DatePipe]
})
export class ViewMetadataComponent implements OnInit {

  @ViewChild('editor') editor: JsonEditorComponent;
  @ViewChild('editorMult') editorMult: JsonEditorComponent;
  @ViewChild('initiateForm') initiateForm: NgForm;

  showData;

  options = new JsonEditorOptions();
  data: any = {
    products: [{
      name: 'car',
      product: [{
        name: 'honda',
        model: [
          { id: 'civic', name: 'civic' },
          { id: 'accord', name: 'accord' },
          { id: 'crv', name: 'crv' },
          { id: 'pilot', name: 'pilot' },
          { id: 'odyssey', name: 'odyssey' }
        ]
      }]
    }]
  };


  data2 = { ...this.data };
  options2 = new JsonEditorOptions();


  @Input() document: any;
  @Output() openMetaData = new EventEmitter<boolean>();
  @Output() close = new EventEmitter<boolean>();
  @Output() refreshDetails = new EventEmitter<boolean>();
  propertyKeys: String[] = [];
  toggleUpdate: Boolean = true;
  updateMessage: Boolean = false;
  values: any[];
  properties: any;
  valuesForm: FormGroup;
  hideFields = ["SF Application ID", "Digitization User Info", "Portal User Info", "Reference Entities", "Source", "Legacy Folder ID", "Batch ID", "ImageTrust Document ID", "Deletion Requested By", "Deletion Requested Date"];
  isError = false;
  errorMessage = '';
  isAdmin = false;
  adminShowFields = ["Legacy Folder ID"];

  constructor(
    private datePipe: DatePipe
  ) {

    this.options2.language = 'en';
    this.options.mode = 'code';
    this.options2.mode = 'tree';
    this.options2.modes = this.options.modes = ['form', 'tree', 'view'];
    this.options2.statusBar = this.options.statusBar = false;
    this.isAdmin = JSON.parse(localStorage.getItem("isAdmin"));

    this.options2.onSelectionChange = () => {
      console.log(`onSelectionChange`)
    }
  }

  showJson(d) {
    return JSON.stringify(d, null, 2);
  }

  getData(data, index) {
    this.values[index].value = data;    
  }

  changeLog(event = null) {
    this.showData = this.editor.get();
  }

  ngOnInit(): void {
    var strArrayAttributes = []
    this.document.categoryMetaData.properties.forEach(element => {
      this.propertyKeys.push(element.name);
      if (!this.hideFields.includes(element.name)) {
        if (element.data_type == 'str array') {
          strArrayAttributes.push(element.name)
        }
      }
      if (this.hideFields.includes(element.name) && !this.adminShowFields.includes(element.name)) {
        element["isHide"] = true
      } else if (!this.isAdmin && this.adminShowFields.includes(element.name)) {
        element["isHide"] = true
      } else if (this.isAdmin && this.adminShowFields.includes(element.name)) {
        element["isHide"] = false
      } else {
        element["isHide"] = false
      }
    });
    this.values = Object.assign({}, this.document.metadata.properties)
    this.properties = {}
    this.propertyKeys.forEach(key => {
      if (this.values[String(key)]) {
        this.properties[String(key)] = this.values[String(key)]
      } else {
        this.properties[String(key)] = undefined
      }
      if (this.values[String(key)] == true) {
        this.values[String(key)] = "true";
      }
      if (this.values[String(key)] == false) {
        this.values[String(key)] = "false";
      }
      if (key.includes("Date")) {
        if (this.values[String(key)] != '' && this.values[String(key)] != null) {
          const d = new Date(this.values[String(key)]);
          const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
          let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
          this.values[String(key)] = dateString;
        }
      }      
    })
    if (strArrayAttributes.length > 0) {
      this.createValuesForm(strArrayAttributes)
    }
  }

  createValuesForm(arrayProperties) {
    var formControlObject = {}
    arrayProperties.forEach(property => {
      formControlObject[property] = new FormArray([this.initValues()])
    });
    this.valuesForm = new FormGroup(
      formControlObject
    )
    this.setVaulesHandler(arrayProperties)
  }

  setVaulesHandler(arrayProperties) {
    var formData = {}
    arrayProperties.forEach(element => {
      this.deleteForm(0, element)
      if (this.values[element]) {
        var values = []
        this.values[element].forEach(arrayValue => {
          this.addNewValue(element)
          values.push({ value: arrayValue })
        });
        formData[element] = values
      } 
    });
    this.valuesForm.patchValue(formData)
  }

  initValues() {
    return new FormGroup({
      value: new FormControl('', Validators.required)
    })
  }

  addNewValue(property) {
    const control = <FormArray>this.valuesForm.get(property);
    control.push(this.initValues());
  }

  getValues(form, property) {
    return form.controls[property].controls;
  }

  deleteForm(index: number, property) {
    this.valuesArray(property).removeAt(index);
  }

  valuesArray(property) {
    return <FormArray>this.valuesForm.get(property)
  }

  trackByIndex(index, item) {
    return item.id;
  }

  onClose(): void {
    //this.dialogRef.close();
    this.openMetaData.emit(false)
  }

  onCancel() {
    this.close.emit(true)
  }

  makeOptions = () => new JsonEditorOptions();

}
